import { gql } from '@apollo/client';

export const GET_TOP_PICK_WINNERS_DETAILS = gql`
  query GetTopPickWinnersDetails(
    $analysisTypeId: Float
    $timePeriod: String
    $groupBy: String
    $page: Float
    $pageSize: Float
  ) {
    topPickWinnersDetails(
      analysisTypeId: $analysisTypeId
      timePeriod: $timePeriod
      groupBy: $groupBy
      page: $page
      pageSize: $pageSize
    ) {
      races {
        raceId
        raceNumber
        raceName
        trackName
        trackCode
        state
        meetingDate
        raceTime
        distance
        trackCondition
        raceClass
        isConsensus
        topPickWinner {
          horseName
          horseNumber
          winningPrice
          position
          jockey
          trainer
          margin
          assessedOdds
          marketOdds
        }
      }
      totalCount
      page
      pageSize
      hasMore
    }
  }
`;